@if (loading) {
  <div>
    <div class="loader"></div>
  </div>
}
